export const AsyncStateInit = 'Init'
export const AsyncStateLoading = 'Loading'
export const AsyncStateSuccess = 'Success'
export const AsyncStateError = 'Error'
